"use client";

import { useSyncExternalStore } from "react";
const subscribe = (onStoreChange: () => void): (() => void) => {
  document.addEventListener("visibilitychange", onStoreChange);
  return (): void => document.removeEventListener("visibilitychange", onStoreChange);
};
const getSnapshot = (): DocumentVisibilityState => document.visibilityState;

// Assume visible on the server, matching the previous default.
const getServerSnapshot = (): DocumentVisibilityState => "visible";
export const useDocumentVisible = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) === "visible";
};